"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileOptionsState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const slate_1 = require("slate");
const slate_react_1 = require("slate-react");
const downloadBlob_1 = require("@jsonjoy.com/collaborative-ui/lib/util/downloadBlob");
const file_1 = require("../../../behavior/file");
class FileOptionsState {
    constructor(mutxt, element, closePopup) {
        this.mutxt = mutxt;
        this.element = element;
        this.closePopup = closePopup;
        this.caption = ui_1.rsync.val('');
        this.displayName = ui_1.rsync.val('');
        this.setElement = (element) => {
            this.element = element;
            this.syncFromElement(element);
        };
        this.setClosePopup = (closePopup) => {
            this.closePopup = closePopup;
        };
        this.setCaption = (value) => {
            this.caption.set(value);
        };
        this.setDisplayName = (value) => {
            this.displayName.set(value);
        };
        this.cancel = () => {
            this.syncFromElement(this.element);
            this.closePopup?.();
        };
        this.apply = () => {
            const editor = this.mutxt.editor;
            const path = slate_react_1.ReactEditor.findPath(editor, this.element);
            const nextCaption = this.caption.value.trim();
            const prevCaption = (this.element.caption ?? '').trim();
            if (nextCaption !== prevCaption) {
                if (nextCaption) {
                    slate_1.Transforms.setNodes(editor, { caption: nextCaption }, { at: path });
                }
                else {
                    slate_1.Transforms.unsetNodes(editor, 'caption', { at: path });
                }
            }
            const nextName = this.displayName.value.trim();
            const thing = this.mutxt.things.get(this.element['@thing']);
            if (thing && nextName !== (thing.name ?? '')) {
                this.mutxt.things.update(this.element['@thing'], { name: nextName || undefined });
            }
            this.closePopup?.();
        };
        this.remove = () => {
            const editor = this.mutxt.editor;
            const path = slate_react_1.ReactEditor.findPath(editor, this.element);
            if ((0, file_1.removeFileAtPath)(editor, path))
                this.closePopup?.();
        };
        this.download = () => {
            const thing = this.mutxt.things.get(this.element['@thing']);
            if (!thing || !thing.data)
                return;
            const blob = new Blob([thing.data], { type: thing.mimeType || 'application/octet-stream' });
            (0, downloadBlob_1.downloadBlob)(blob, thing.name || 'file');
        };
        this.syncFromElement = (element) => {
            this.caption.set(element.caption ?? '');
            const thing = this.mutxt.things.get(element['@thing']);
            this.displayName.set(thing?.name ?? '');
        };
        this.syncFromElement(element);
    }
}
exports.FileOptionsState = FileOptionsState;
